import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BOOKING_URL } from "../data/content";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Booking = ({ b }) => {
  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="relative overflow-hidden bg-[#172033] text-[#F6F5F1]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="overline text-[#D9B87A] mb-8"
        >
          {b.overline}
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <motion.h2
              custom={1}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="font-serif-display italic font-light text-4xl md:text-6xl leading-[1.02] tracking-tight"
            >
              {b.title}
            </motion.h2>
            <motion.p
              custom={2}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="mt-8 text-[#F6F5F1]/80 text-base md:text-lg font-light leading-relaxed max-w-xl"
            >
              {b.text}
            </motion.p>
          </div>

          <motion.div
            custom={3}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="lg:col-span-5 lg:col-start-8"
          >
            <div className="border border-[#F6F5F1]/25 rounded-sm p-8">
              <div className="overline text-[#D9B87A] text-[0.6rem]">{b.codeLabel}</div>
              <div
                data-testid="discount-code"
                className="mt-3 font-serif-display text-4xl md:text-5xl tracking-[0.12em] text-[#F6F5F1]"
              >
                {b.code}
              </div>

              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="booking-cta"
                className="group mt-8 flex items-center justify-between gap-4 bg-[#B0863A] text-[#172033] rounded-full pl-7 pr-3 py-3 font-semibold text-sm hover:bg-[#C9A24E] transition-colors duration-400"
              >
                <span>{b.cta}</span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#172033] text-[#F6F5F1] transition-transform duration-500 group-hover:rotate-45">
                  <ArrowUpRight size={18} strokeWidth={1.6} />
                </span>
              </a>
            </div>

            <p className="mt-5 text-[#F6F5F1]/55 text-xs leading-relaxed">{b.note}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
